module.exports = __webpack_public_path__ + "6a53b8ed8090d3d72f3d10157653e633.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-27.png
// module id = 2224
// module chunks = 0